import React from 'react'

export default function GiftingLuxury() {
  return (
    <>
    <section className="giftpage-luxury">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h4 className="heading center-heading">Creating an Era of Luxury & Gifting</h4>
                </div>

                <div className="col-lg-4 col-md-4">
                    <div className="giftluxury-box wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/gift-luxury-1.webp" alt="icon" loading="lazy"/>
                        <span>Thoughtful Luxury</span>
                        <p>At Sonam Label, every bride is invited into a world where timeless craftsmanship meets contemporary elegance.</p> 
                    </div>
                </div>

                <div className="col-lg-4 col-md-4">
                    <div className="giftluxury-box wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/gift-luxury-2.webp" alt="icon" loading="lazy"/>
                        <span>Conscious Craftsmanship</span>
                        <p>At Sonam Label, heritage craftsmanship is thoughtfully reimagined with contemporary elegance for every bride.</p>
                    </div>
                </div>

                <div className="col-lg-4 col-md-4">
                    <div className="giftluxury-box wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <img src="/image/gift-luxury-3.webp" alt="icon" loading="lazy"/>
                        <span>Moments Made Magical</span>
                        <p>At Sonam Label, brides are welcomed into an experience where artisanal traditions blend seamlessly with modern sophistication.</p>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
